import { ArrowButtonProps } from '@/common/types';
import styled from '@emotion/styled';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import React from 'react';

const ArrowButton = styled.button`
  background-color: #fff;
  border: none;
  border-radius: 50%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  min-height: 40px;
  min-width: 40px;
  outline: none;
  padding: 0;
  position: relative;
  right: 50px;

  &:hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
    min-height: 32px;
    min-width: 32px;
    right: 20px;
  }
`;

const ArrowIcon = styled(ArrowForwardIosOutlinedIcon)`
  color: #888888;
`;

const ArrowLeftButton = ({onClick}:ArrowButtonProps) => {
  return (
    <ArrowButton onClick={onClick}>
      <ArrowIcon sx={{fontSize:"14px"}}/>
    </ArrowButton>
  );
};

export default ArrowLeftButton;